import * as PropTypes from 'prop-types';
import * as React from 'react';
import SocialLink from './social_link';
import ShareInput from './share_input';

const ShareItem = ({ shareLinks }) => (
  <div className="listing-share module module-footer module-footer--listing-share btm-round-module">
    <div className="g-container">
      <div className="g-col-6 g-col-mobile-12 mobile-align-center mobile-mb-1">
        <ShareInput
          href={shareLinks.shortlink.href}
        />
      </div>
      <div className="g-col-6 g-col-mobile-12 align-right mobile-align-center">
        <div className="social-trackable with-spacing">
          <SocialLink link={shareLinks.share_facebook.href} type="facebook" />
          <SocialLink link={shareLinks.share_twitter.href} type="twitter" />
          <SocialLink link={shareLinks.share_pinterest.href} type="pinterest" />
          <SocialLink link={shareLinks.share_email.href} type="email" icon="envelope" />
        </div>
      </div>
    </div>
  </div>
);

ShareItem.propTypes = {
  shareLinks: PropTypes.object.isRequired,
};

export default ShareItem;



// WEBPACK FOOTER //
// ./javascripts/components/shared/share_item.jsx